angular.module('jv.Admin.Users.Administration.Details.Controller', ['jv.Common.Directives.Breadcrumbs'])
.controller('jvAdminUsersAdministrationDetailsController', ['$scope','$window', '$routeParams', 'jvAdminUsersAdministrationService',function ($scope, $window, $routeParams, jvAdminUsersAdministrationService) {
  var state = $scope.state = {
    selectedDomain: 'Requisition',
    permissionDomains: [],
    permissionCategories: [],
    collapsed: false,
    filterPermissionData: {},
    filterPermission: true
  };

  var breadcrumbsConfig = { links: []};
  breadcrumbsConfig.links.push({
    linkText: i18n['ADMIN'],
    link: '/admin/config/users/index.html#/users/employees/details/'+$routeParams.id +'/'+$routeParams.index +'/'+$routeParams.count +'/'+$routeParams.page
  });

breadcrumbsConfig.links.push({
    linkText: i18n['USERS'],
    link: '/admin/config/users/index.html#/users/employees/details/'+$routeParams.id +'/'+$routeParams.index +'/'+$routeParams.count +'/'+$routeParams.page
  }); 
  
$scope.breadcrumbsConfig = breadcrumbsConfig;
  $scope.showDisabledPermission = true;
  
  $scope.toggleFiltersDropdown = function(){
    $scope.filterArrowDown = !$scope.filterArrowDown;
  };

   $scope.hideFiltersDropdown = function() {
        $scope.filterArrowDown = false;
    };

  $scope.showHiddenPermission = function(showDisabledPermission){
    if(showDisabledPermission){
       state.filterPermission = true;
     }else{
       state.filterPermission = false;
     }
  };

  $scope.expandAll = function() {
    angular.forEach(state.permissionCategories, function(permissionCategory, key) {
      permissionCategory.collapse = false;
    });
  };

  $scope.collapseAll = function() {
    angular.forEach(state.permissionCategories, function(permissionCategory, key) {
      permissionCategory.collapse = true;
    });
  };

  $scope.roleDetails = state.permissionCategories;
  $scope.filterState = state.filterPermissionData;

  var userObject = $scope.userObject = {
    details: {},
    email: $routeParams.id,
    roles: '',
    permissions: {},
  }

  var getRoles = function(email) {
    var requestObject = {}
    requestObject.email = email;
    jvAdminUsersAdministrationService.getRole(requestObject, function(data) {
      userObject.details = data.user;
      getCommaSeperatedRoles(data.roles);
    }, function() {
      console.log("Error");
    })
  };
  
  var getCommaSeperatedRoles = function(roles) {
	  var roleList = "";
	  angular.forEach(roles, function(value, key) {
		  if(value.label) {
			  if(key === 0) {
				  roleList = value.label;
			  } else {
				  roleList = roleList + ", " + value.label;
			  }
		  }
      });
	  userObject.roles = roleList;
  };

  var getPermissions = function(email) {
    var requestObject = {}
    requestObject.email = email;
    jvAdminUsersAdministrationService.getPermissions(requestObject, function(data) {

      $scope.showDomains = data.domains;
      massageDomains(data.permissions);
      var domain = getDefaultDomain(state.permissionDomains);
      state.permissionCategories = domain.permissionCategories;
    }, function() {
      console.log("Error");
    })
  };
  
  $scope.selectPermissionDomain = function(domain) {
    var requestObject = {};
    state.selectedDomain = domain.id;
    if (state.selectedDomain === "CustomField") {
    	requestObject.domain = "CustomFields";
      requestObject.email = userObject.email;
        jvAdminUsersAdministrationService.getPermissionsByDomain(requestObject, function(data) {
        	state.permissionCategories = data.permissions;
            angular.forEach(state.permissionCategories, function(value, key){
                if (value.viewFieldPermissionTOs && value.viewFieldPermissionTOs.length > 0) {
                    state.selectedPermissionCategory = value;
                }
            });
          }, function() {
            console.log("Error");
          });
    } else {
        state.permissionCategories = domain.permissionCategories;
    }
  }
  
  var getDefaultDomain = function(permissionDomains) {
      state.selectedDomain = permissionDomains[0].id;
      return permissionDomains[0];
  }
  
  var massageDomains = function(permissionDomains) {
      angular.forEach(permissionDomains, function(domainValue, key) {
          var permissionDomain = {};
          permissionDomain.id = domainValue.domain;
          permissionDomain.label = domainValue.domainLabel;
          permissionDomain.permissionCategories = domainValue.categoryToPermissionsTOs;
          if (key === 0) {
              permissionDomain.selected = true;
          }
          massagePermissions(permissionDomain);
          state.permissionDomains.push(permissionDomain);
      });
      
/*    var permissionDomain = {};
      permissionDomain.id = "CustomField";
      permissionDomain.label = "Custom Fields";
      state.permissionDomains.push(permissionDomain);*/
  }
  
  var convertPermission = function(permission) {
        var permissionResponse = {};
        permissionResponse.enable = permission.enable;
        permissionResponse.permissionKey = permission.code;
        permissionResponse.sId = permission.SId;
        if (permissionResponse.enable && permission.selectedAccountable) {
            permissionResponse.accountableKey = permission.selectedAccountable.key;
        }
        return permissionResponse;
        
    };
    
  var massagePermissions = function(permissionDomain) {
      //Traverse through all permission categories
      angular.forEach(permissionDomain.permissionCategories, function(permissionCategory, key){
          //This will be used to collapse/expand each category
          permissionCategory.collapse = false;
          //Traverse through permissions within a category to set the selectedAccountable etc. 
          angular.forEach(permissionCategory.permissionTOs, function(permission, key){
              if (permission.accountableTOs && permission.accountableTOs.length > 0) {
                  angular.forEach(permission.accountableTOs, function(accountable, key) {
                      if (accountable.enable) {
                          permission.selectedAccountable = accountable;
                      }
                  });
              };
          });
      });
  };
  
  

  getRoles(userObject.email);
  getPermissions(userObject.email);
  
}]);
